// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__G0NJM"};